import React, { useState, useEffect, useRef } from "react";
import './csr.css';  // Optional: If you want to add custom styles
import { db } from '../AppointmentComp/firebase'; // Make sure the path is correct
import { collection, addDoc } from 'firebase/firestore'; // Import necessary methods

import Slider from 'react-slick';

const stats = [
  { value: 17, suffix: "+", label: "Years of Experience" },
  { value: 50, suffix: "+", label: "Projects Completed" },
  { value: 300, suffix: "+", label: "Volunteers" },
  { value: 34000, suffix: "+", label: "Happy Individuals" },
];
function CSR() {
  

  const [displayValues, setDisplayValues] = useState(stats.map(() => 0));
  const sectionRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);





//save data of contactus
const [firstName, setFirstName] = useState("");
const [lastName, setLastName] = useState("");
const [email, setEmail] = useState("");
const [message, setMessage] = useState("");

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    // Add data to Firestore
    await addDoc(collection(db, "contactus"), {
      firstName,
      lastName,
      email,
      message,
    });
    alert("Message submitted successfully!");
    setFirstName("");
    setLastName("");
    setEmail("");
    setMessage("");
  } catch (error) {
    console.error("Error adding document: ", error);
    alert("Failed to submit message.");
  }
};







const organizations = [
    { image: "/org1.png" },
    { image: "/org2.png" },
    { image: "/org3.png" },
    { image: "/org4.jpg" },
    { image: "/org5.png" },
    { image: "/org6.png" },
    { image: "/org7.png" },
    { image: "/org8.png" },
    { image: "/org9.png" },
    { image: "/org10.png" },
    { image: "/org11.jpg" },

  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  const Carosettings = {

    infinite: true, // Infinite scroll
    speed: 500, // Transition speed
    slidesToShow: 5, // Show one image at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Enable auto play
    autoplaySpeed: 2000, // Change image every 2 seconds
    pauseOnHover: true // Pause when hover
  };









  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          const intervals = stats.map((stat, index) => {
            return setInterval(() => {
              setDisplayValues((prevValues) => {
                const newValues = [...prevValues];
                if (newValues[index] < stat.value) {
                  newValues[index] += Math.ceil(stat.value / 100); // Increment speed
                } else {
                  newValues[index] = stat.value;
                  clearInterval(intervals[index]);
                }
                return newValues;
              });
            }, 30);
          });

          return () => intervals.forEach(clearInterval);
        }
      },
      { threshold: 0.2 } // Trigger when 20% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);




  

  return (
  <>
    {/* Banner Image */}
          <div className="banner">
            <img src="/banner-csr.jpg" alt="CSR Banner" className="banner-image" />
          </div>

        <div className="csr-page">

          <div className="csr-details">
            <h2>Our Commitment</h2>
            <p>At Eye Care Optical, we are committed to not only providing exceptional eye care products and services but also to enhancing the well-being of our communities through responsible corporate practices. Our CSR initiatives focus on improving the quality of life, promoting health and wellness, and contributing to the social and environmental sustainability of the world. Here are some of the key areas we focus on:</p>
            
            <ol>
              <li><strong>Access to Eye Care for All</strong> – We recognize that good vision is a fundamental part of quality of life, and yet many individuals, particularly in underserved communities, lack access to eye care services. Our "Eyes for All" initiative works to provide free eye exams, glasses, and vision treatments to those who cannot afford them. We partner with local charities, schools, and community centers to offer regular outreach programs for individuals in need.</li>
              <li><strong>Sustainability in Product Manufacturing</strong> – At Eye Care Optical, we are dedicated to reducing our environmental impact. We source eco-friendly materials for our frames, lenses, and packaging, including biodegradable and recyclable materials. We work with suppliers who adhere to sustainable practices to minimize the carbon footprint of our operations and ensure that our products contribute to a healthier planet.</li>
              <li><strong>Community Health and Education Programs</strong> – We support and participate in various health and wellness campaigns, particularly those focusing on vision health education. Through collaborations with local schools, universities, and public health organizations, we conduct seminars and workshops to raise awareness about the importance of eye health, proper eye care, and regular eye exams. Our goal is to educate individuals on how to prevent eye diseases and maintain optimal vision.</li>
              <li><strong>Support for Vision Impairment and Rehabilitation</strong> – For individuals suffering from vision impairment, Eye Care Optical offers specialized support services, including rehabilitation programs, to help them adapt to their new way of life. We provide access to assistive technology, such as screen readers and magnification tools, as well as support networks for people living with visual disabilities.</li>
              <li><strong>Ethical Sourcing and Fair Trade Practices</strong> – We are committed to ethical business practices, and this extends to the way we source our materials and products. Our suppliers are chosen based on their adherence to fair trade principles, ensuring that workers in the supply chain are treated fairly, receive appropriate wages, and work in safe environments. By supporting these practices, we help improve the livelihoods of individuals in communities where our products are made.</li>
              <li><strong>Employee Engagement and Volunteering</strong> – At Eye Care Optical, we encourage our employees to participate in CSR activities and community volunteer efforts. Through company-sponsored volunteering days and fundraising initiatives, our team actively contributes to causes close to their hearts. Whether it's participating in charity runs, providing pro bono services to those in need, or contributing to local food banks, we believe in fostering a culture of giving back.</li>
              <li><strong>Support for Research and Innovation in Eye Care</strong> – We contribute to the advancement of research in the field of ophthalmology and vision care. By partnering with research institutions and universities, we help fund innovative projects that aim to develop better treatments for eye diseases, improve eye care technologies, and make vision care more accessible.</li>
              <li><strong>Disaster Relief and Humanitarian Aid</strong> – In times of natural disasters or humanitarian crises, we provide financial support, donate eye care products, and offer essential services to those affected. Our disaster relief efforts aim to address immediate needs, such as emergency eye care and the distribution of essential vision aids, and we collaborate with organizations working on long-term recovery initiatives.</li>
              <li><strong>Promoting Diversity and Inclusion</strong> – Eye Care Optical is dedicated to fostering an inclusive workplace where diversity is celebrated. We actively recruit and support individuals from diverse backgrounds, ensuring equal opportunities for all. We also create products that cater to a wide range of people, recognizing that everyone’s vision needs are unique.</li>
            </ol>
          </div>
        </div>


   
          <div className="giving-at-a-glance" ref={sectionRef}>
          <div className="content-wrapper">
            <h1 className="stat-heading">Highlights</h1>
            <div className="stats-container">
              {stats.map((stat, index) => (
                <div className="stat" key={index}>
                  <span className="stat-value">
                    {displayValues[index].toLocaleString()}
                    {stat.suffix}
                  </span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>


        <div className="contact-container">
      <div className="form-section">
        <h1>Contact Us</h1>
        <p>Strike Up a Conversation With Us!</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="first-name">
              Name <span>*</span>
            </label>
            <div className="name-input">
              <input
                type="text"
                id="first-name"
                placeholder="First"
                required
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input
                type="text"
                id="last-name"
                placeholder="Last"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="email">
              Email <span>*</span>
            </label>
            <input
              type="email"
              id="email"
              placeholder="Your Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Comment or Message</label>
            <textarea
              id="message"
              placeholder="Your Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
      </div>


      <div className="info-section">
        <h2>Our Locations</h2>
        <p>
          No: 674/8,
          <br />
          Maradana Road,
          <br />
          Colombo 10
        </p>

        <p>
          No: 23,
          <br />
          Uswatta Circular Road,
          <br />
          Moratuwa
        </p>
        <h2>Working Hours</h2>
        <p>
          Monday, Tuesday, Wednesday,  
          Friday and Saturday : 9.00 am – 6.00 pm<br />
          Thursday and Sunday: Closed
        </p>
        <h2>Contact Us</h2>
        <p>
          Phone: +94 11 7 700904 | +94 76 136 0946
          <br />
          Email: cecc.maradana@gmail.com | cecc.moratuwa@gmail.com
           
        </p>
      </div>
    </div>



    <div className="carousel-container">
      <Slider {...Carosettings}>
        {organizations.map((organizations, index) => (
          <div key={index} className="organizations-slide">
            <img src={organizations.image} alt={organizations.name} className="organizations-image" />
            <h3>{organizations.name}</h3>
          </div>
        ))}
      </Slider>
    </div>

    </>
  );
}

export default CSR;
